import React, { useState } from 'react';

const plans = [
  {
    name: 'Basic',
    price: 'Free',
    features: ['Limited speed', '1 Device', 'Ads supported'],
  },
  {
    name: 'Standard',
    price: '$5/mo',
    features: ['Fast speed', '3 Devices', 'No ads'],
  },
  {
    name: 'Premium',
    price: '$20/mo',
    features: ['Unlimited speed', 'Unlimited Devices', 'Priority support'],
  },
];

export default function OpenFiLandingPage() {
  const [activeTab, setActiveTab] = useState('signin');

  return (
    <div className="min-h-screen bg-gray-50 font-sans text-gray-800">
      <header className="bg-white shadow p-6 flex justify-between items-center container mx-auto">
        <h1 className="text-2xl font-bold text-blue-600">OpenFi</h1>
        <div>
          <button
            className={`mr-4 px-4 py-2 rounded-md border ${activeTab === 'signin' ? 'bg-blue-600 text-white' : 'bg-white text-blue-600 border-blue-600'}`}
            onClick={() => setActiveTab('signin')}
          >
            Sign In
          </button>
          <button
            className={`px-4 py-2 rounded-md border ${activeTab === 'signup' ? 'bg-blue-600 text-white' : 'bg-white text-blue-600 border-blue-600'}`}
            onClick={() => setActiveTab('signup')}
          >
            Sign Up
          </button>
        </div>
      </header>

      <main className="container mx-auto px-6 py-12">
        <section className="text-center mb-12">
          <h2 className="text-4xl font-extrabold mb-3">Connect Smarter with OpenFi</h2>
          <p className="text-lg text-gray-600">Choose a plan that fits your needs and get connected instantly.</p>
        </section>

        <section className="mb-16 max-w-lg mx-auto bg-white p-8 rounded-lg shadow-md">
          {activeTab === 'signin' ? (
            <form className="space-y-4">
              <h3 className="text-2xl font-semibold text-gray-800 text-center">Sign In</h3>
              <input type="email" placeholder="Email" className="w-full p-3 border border-gray-300 rounded" />
              <input type="password" placeholder="Password" className="w-full p-3 border border-gray-300 rounded" />
              <button type="submit" className="w-full bg-blue-600 text-white p-3 rounded hover:bg-blue-700">
                Sign In
              </button>
            </form>
          ) : (
            <form className="space-y-4">
              <h3 className="text-2xl font-semibold text-gray-800 text-center">Sign Up</h3>
              <input type="text" placeholder="Full Name" className="w-full p-3 border border-gray-300 rounded" />
              <input type="email" placeholder="Email" className="w-full p-3 border border-gray-300 rounded" />
              <input type="password" placeholder="Password" className="w-full p-3 border border-gray-300 rounded" />
              <button type="submit" className="w-full bg-blue-600 text-white p-3 rounded hover:bg-blue-700">
                Create Account
              </button>
            </form>
          )}
        </section>

        <section className="grid gap-8 md:grid-cols-3">
          {plans.map((plan) => (
            <div key={plan.name} className="bg-white p-6 rounded-lg shadow-md hover:shadow-xl transition">
              <h4 className="text-xl font-bold text-blue-600 mb-2 text-center">{plan.name}</h4>
              <p className="text-center text-3xl font-extrabold mb-4">{plan.price}</p>
              <ul className="text-gray-700 mb-6 space-y-2 text-center">
                {plan.features.map((feature, idx) => (
                  <li key={idx}>• {feature}</li>
                ))}
              </ul>
              <div className="text-center">
                <button className="bg-blue-500 text-white px-6 py-2 rounded hover:bg-blue-600">
                  Subscribe
                </button>
              </div>
            </div>
          ))}
        </section>
      </main>

      <footer className="text-center p-6 text-gray-500 text-sm">
        &copy; {new Date().getFullYear()} Araknerd Company Ltd. All rights reserved.
      </footer>
    </div>
  );
}
